import React from 'react';
export const AppContext = React.createContext(null);
export const ProfileContext = React.createContext(null);
export const MedicalRecordContext = React.createContext(null);
